<div class="modal fade" id="modalDefaultContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">

  <div class="modal-dialog cascading-modal modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header darken-3 justify-content-center text-center text-white contactmodal">
        <h4 class="text-uppercase font-weight-bold text-center mx-5 pt-2">
          <i class="fa fa-pencil-alt px-2"></i> Contact form </h4>
          <button type="button" class="close waves-effect waves-light " data-dismiss="modal" aria-label="Close"
            (click)="dialogRef.close()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <mdb-card-body>
            <p>Kindly provide us with the following information to help us serve you better.</p>

            <form class="form" #contactusform="ngForm"  (ngSubmit)="contactusform.form.valid && onSubmit()"
              novalidate>
              <div id="success" class="toast-alert alert-success hide mt-3 "
                role="alert"
                data-delay="5000"
                data-autohide="false" aria-live="assertive" aria-atomic="true">

                <div class="toast-body">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  {{alertMsg}}
                </div>
              </div>
              <div id="error" class="toast-alert alert-danger hide mt-3"
                role="alert"
                data-delay="5000"
                data-autohide="true" aria-live="assertive" aria-atomic="true">

                <div class="toast-body">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  {{alertMsg}}
                </div>
              </div>
              <div class="md-form ">

                <input type="text" name="clientname" class="form-control required"
                  placeholder="Client/Project Name" [(ngModel)]="contactmodel.clientname"
                  #clientname="ngModel" required autocomplete="off"
                  maxlength="200"
                  pattern="^[0-9a-zA-Z''-'\s]{1,100}$"/>

                  @if ((clientname.touched || contactusform.submitted) && (clientname.errors?.required || clientname.errors?.pattern )) {
                    <span class="text-danger"
                      >
                      Valid ClientName is required
                    </span>
                  }
                </div>



                <div class="md-form required">
                  <select class="browser-default custom-select " name=" clientmarket"
                    [(ngModel)]="contactmodel.clientmarket" #clientmarket="ngModel" required autocomplete="off" >
                    <option value="">Select Client Market</option>
                    @for (cm of clientmarketlist; track cm.GeoId) 
                    {  <option [value]="cm.GeoId">{{ cm.GeoDesc }}
                    </option>}
                  </select>

                  @if ((clientmarket.touched || contactusform.submitted) && clientmarket.errors?.required) {
                    <span class="text-danger"
                      >
                      Please select valid Clientmarket
                    </span>
                  }

                </div>


                <div class="md-form required">
                  <select class="browser-default custom-select " name=" clientindustry"
                    [(ngModel)]="contactmodel.clientindustry" #clientindustry="ngModel" required autocomplete="off" >
                    <option value="">Select Client Industry</option>
                     @for (ci of clientindustrylist; track $index) 
                     {  <option [value]="ci.IgId">{{ ci.IgDesc }}</option>}
                  </select>

                  @if ((clientindustry.touched || contactusform.submitted) && clientindustry.errors?.required) {
                    <span class="text-danger"
                      >
                      Please select valid Clientindustry
                    </span>
                  }

                </div>


                <div class="md-form required">
                  <select class="browser-default custom-select " name=" usecase"
                    [(ngModel)]="contactmodel.usecase" #usecase="ngModel" required autocomplete="off" >
                    <option value="">Select Usecase</option>
                    @for (uc of usecaselist; track $index) {  <option [value]="uc.UseCaseId">{{ uc.UseCaseDesc }}  </option>}
                  </select>

                  @if ((usecase.touched || contactusform.submitted) && usecase.errors?.required) {
                    <span class="text-danger"
                      >
                      Please select valid Usecase
                    </span>
                  }
                </div>


                <div class="md-form">
                  <textarea class="form-control" name="additionalinfo" rows="2"
                    placeholder="Additional Information" [(ngModel)]="contactmodel.additionalinfo"
                    maxlength="2000" autocomplete="off" >
                  </textarea>
                </div>

                <div class="text-center">
                  <button type="submit"
                    class="btn basebtn text-uppercase contactbtn mr-3 waves-effect z-depth-0">


                    Submit
                    <i class="fas fa-angle-double-right"></i>
                  </button>



                  <button type="reset"
                    class="btn basebtn text-uppercase contactCancelbtn waves-effect z-depth-0"
                    (click)="formreset()">
                    <i class="fas fa-window-close"></i>
                    Reset

                  </button>


                </div>
                <div style="position: absolute; top: 0; right:15;">


                </div>



              </form>
            </mdb-card-body>




          </div>



        </div>

      </div>

    </div>